<template>
    <div class="inbox-wrapper">
        <div class="chat-header">
            <div class="header-btn-wrapper">
                <div style="right:0" class="header-btn" @click="close">
                    <BaseIcon class="clickable button-wrapper" name="times" size="1x" />
                </div>
                <div style="right:30px;" class="header-btn" @click="minimize">
                    <BaseIcon class="clickable button-wrapper" name="minus" size="1x" />
                </div>
            </div>
            <div class="header-content-wrapper">
                <div
                    class="header-avatar-wrapper"
                    :style="{ backgroundColor: stringToColor(activeConversation.id) }"
                >
                    <div
                        v-if="getAvatar()"
                        :style="{
                            backgroundImage: 'url(\'' + getAvatar() + '/small.jpg\')',
                        }"
                        class="avatar"
                    ></div>
                    <div v-else style="display:flex;align-items:center;">
                        <BaseIcon class="icon" name="user" />
                    </div>
                </div>
                <div class="header-details-wrapper">
                    <div class="header-details-name">
                        <strong>{{ getConversationParticipantName() }}</strong>
                    </div>
                    <div class="header-details-title">{{ getConversationParticipantTitle() }}</div>
                </div>
            </div>
        </div>
        <div id="inbox-container" class="chat-body">
            <Spinner />
        </div>
    </div>
</template>

<script>
import Talk from 'talkjs';

// Components
import Spinner from '../builders/Spinner';

// Utils
import stringToColor from '~~utils/stringToColor';

export default {
    name: 'Inbox',
    components: { Spinner },
    props: {
        conversationId: String,
        activeConversation: {},
        session: {},
    },
    data() {
        return {
            inbox: {},
        };
    },
    watch: {
        conversationId: function(val) {
            if (val) {
                const conversation = this.session.getOrCreateConversation(val);
                this.inbox.select(conversation);
                this.$emit('update-unread', val, false);
            }
        },
    },
    methods: {
        stringToColor(str) {
            return stringToColor(str);
        },
        minimize() {
            this.$emit('minimize');
        },
        close() {
            this.$emit('close', this.conversationId);
        },
        getAvatar() {
            let { activeConversation } = this;
            return activeConversation &&
                activeConversation.participants &&
                activeConversation.participants.length
                ? activeConversation.participants[0].avatar
                : null;
        },
        getConversationParticipantName() {
            let { activeConversation } = this;

            return activeConversation &&
                activeConversation.participants &&
                activeConversation.participants.length
                ? activeConversation.participants[0].displayName
                : 'Unknown';
        },
        getConversationParticipantTitle() {
            let { activeConversation } = this;

            return activeConversation &&
                activeConversation.participants &&
                activeConversation.participants.length &&
                activeConversation.participants[0].title
                ? activeConversation.participants[0].title
                : '';
        },
    },
    mounted() {
        Talk.ready.then(() => {
            const conversation = this.session.getOrCreateConversation(this.conversationId);

            if (!IS_PROD && false) {
                this.session.syncThemeForLocalDev('/talkjs-dev.css');
            }

            this.inbox = this.session.createChatbox(conversation, {
                showChatHeader: false,
            });
            this.inbox.mount(document.getElementById('inbox-container'));
        });
    },
};
</script>

<style scoped>
.inbox-wrapper {
    box-shadow: var(--shadow);
    position: fixed;
    right: 100px;
    bottom: 20px;
    height: 400px;
    width: 300px;
    z-index: 100;
    background-color: white;
    border-radius: 5px;
}
.chat-header {
    padding: 5px;
    height: 60px;
    background: linear-gradient(135deg, rgb(63, 81, 181) 0%, rgb(37, 47, 105) 100%);
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
}
.header-btn-wrapper {
    /*height:10px;*/
}
.header-btn {
    position: absolute;
    color: white;
}
.header-content-wrapper {
    color: white;
    display: flex;
    align-items: center;
}
.header-avatar-wrapper {
    width: 40px;
    height: 40px;
    font-size: 100%;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    border: 2px solid white;
    margin: 5px;
}
.avatar {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
.header-details-wrapper {
    font-size: 13px;
    margin-left: 10px;
}
.chat-body {
    position: absolute;
    bottom: 0;
    height: 340px;
    justify-content: center;
    width: 100%;
    display: flex;
    align-items: center;
}
.minimize {
    color: blue;
}
.button-wrapper {
    padding: 3px 10px !important;
}
</style>
